export default {
  tableHeader: {
    dataId: 'Funkcia',
    spearmanCorrelationCoeff: 'Koeficient nelineárnej korelácie (Spearman)',
    pearsonCorrelationCoeff: 'Koeficient lineárnej korelácie (Pearson)',
  },
};
